import { Component } from 'react';

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 24,
          fontFamily: 'monospace',
          backgroundColor: '#1a1a2e',
          color: '#ff6b6b',
          minHeight: '100vh',
          whiteSpace: 'pre-wrap',
          overflow: 'auto'
        }}>
          <h2 style={{ color: '#fff' }}>Erro ao carregar o app</h2>
          <p>{this.state.error?.toString()}</p>
          <details style={{ marginTop: 16, color: '#aaa' }}>
            <summary>Stack trace</summary>
            <pre>{this.state.error?.stack}</pre>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
